module.exports = __webpack_public_path__ + "static/media/icon-line-clothing.7d4308b0.svg";